module.exports = __webpack_public_path__ + "assets/wallet.d0dfaf5c.svg";